import { useLocation, useNavigate } from 'react-router-dom';
import { Upload, Home, Settings, TrendingUp, Users, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  // TODO: Replace with actual role management logic
  const role = 'admin'; // Options: 'admin', 'supplier'

  const allSidebarItems = [
    { id: 'home', label: 'Update Price', icon: Home, path: '/' },
    { id: 'upload', label: 'Product Feed Management', icon: Upload, path: '/product-feed-management' },
    { id: 'upload2', label: 'Product Feed Management 2', icon: FileText, path: '/product-feed-management-2' },
    { id: 'supplier-product-feed-management', label: 'Supplier Product Feed Management', icon: FileText, path: '/supplier-product-feed-management' },
    { id: 'discount', label: 'Discount Analysis', icon: TrendingUp, path: '/discount-analysis' },
    { id: 'users', label: 'User Approvals', icon: Users, path: '/user-approvals' },
    { id: 'attribute-groups', label: 'Attributes Management', icon: Settings, path: '/attribute-groups' },
  ];

  const sidebarItems = allSidebarItems.filter(item => {
    if (role === 'admin') return true;
    if (role === 'supplier') return item.id === 'supplier-product-feed-management';
    return false;
  });

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <div className="w-80 bg-white shadow-sm border-r">
        <div className="p-6">
          <div className="flex items-center gap-2 mb-8">
            <div className="w-8 h-8 bg-teal-600 rounded flex items-center justify-center">
              <span className="text-white text-sm font-bold">N</span>
            </div>
            <h1 className="font-semibold text-gray-900">Nestingale Internal Tools</h1>
          </div>

          <nav className="space-y-2">
            {sidebarItems.map((item) => (
              <Button
                key={item.id}
                variant={location.pathname === item.path ? "default" : "ghost"}
                className={`w-full justify-start gap-3 ${location.pathname === item.path
                  ? 'bg-teal-600 text-white hover:bg-teal-700'
                  : 'text-gray-600 hover:text-gray-900'
                  }`}
                onClick={() => {
                  if (item.path === "/product-feed-management-2") {
                    const params = new URLSearchParams();
                    params.set('view', 'dashboard');
                    navigate(`${item.path}?${params.toString()}`, { replace: true });
                  } else {
                    navigate(item.path);
                  }
                }
                }
              >
                <item.icon size={20} />
                {item.label}
              </Button>
            ))}
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 p-8">
        {children}
      </div>
    </div>
  );
};

export default MainLayout;